
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"#fff","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.244 4c.687 0 1.244.557 1.244 1.244v4.975a1.244 1.244 0 01-2.488 0V5.244C9 4.557 9.557 4 10.244 4zM9 15.194c0-.687.557-1.244 1.244-1.244h.012a1.244 1.244 0 110 2.488h-.012A1.244 1.244 0 019 15.194z"}})])
          )
        }
      }
    